import { useCallback } from "react";
import {
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
  type UserCredential,
} from "firebase/auth";

import { auth } from "@/lib/firebase";

export type GoogleConfig = {
  webClientId?: string;
};

const googleProvider = new GoogleAuthProvider();

googleProvider.setCustomParameters({
  prompt: "select_account",
});

export async function googleSignInWeb(
  _cfg: GoogleConfig = {}
): Promise<UserCredential> {
  return signInWithPopup(auth, googleProvider);
}

/**
 * Important:
 * Web must also export googleSignIn because your screen imports:
 *
 * import { googleSignIn } from "@/lib/authGoogle";
 */
export async function googleSignIn(
  cfg: GoogleConfig = {}
): Promise<UserCredential> {
  return googleSignInWeb(cfg);
}

export async function googleSignOut(_cfg: GoogleConfig = {}) {
  await signOut(auth);
}

/**
 * Kept for older web files that use the hook style.
 */
export function useGoogleSignIn(cfg: GoogleConfig = {}) {
  const webClientId = cfg.webClientId;

  return useCallback(() => {
    return googleSignInWeb({ webClientId });
  }, [webClientId]);
}
